import {
  addConsultantTagging,
  getAllTags,
  queryTaggings,
  removeTaggings,
} from '../../utilities/angular/tags_helper';

var recruiterFolderSelectComponentTemplate =
  '<div>' +
    '<div class="row" ' +
          'uib-tooltip="To add multiple candidates to a folder, please use the Recruiter Toolbar above" ' +
          'tooltip-popup-delay="800"' +
          'tooltip-enable="vm.disabledAddButton" ' +
          '>' +
      '<div class="col-xs-12 col-sm-8">' +
        '<div class="form-group margin-bottom-medium folder-name">' +
          '<input ' +
            'ng-disabled="vm.disabledAddButton" ' +
            'ng-model="vm.folder" ' +
            'uib-typeahead="folder as folder.name for folder in vm.folders | filter:{name:$viewValue}" ' +
            'typeahead-on-select="vm.checkMatches(vm.folder)" ' +
            'ng-change="vm.checkMatches(vm.folder)" ' +
            'ng-keydown="$event.keyCode === 13 && vm.save(vm.folder)" ' +
            'type="text" ' +
            'placeholder="Enter folder name..." ' +
            'class="form-control input-sm">' +
        '</div>' +
        '<div class="form-group margin-bottom-medium folder-description">' +
          '<input ' +
            'ng-disabled="vm.disabledAddButton" ' +
            'ng-model="vm.folderDescription" ' +
            'ng-keydown="$event.keyCode === 13 && vm.save(vm.folder)" ' +
            'type="text" ' +
            'placeholder="Enter folder description..." ' +
            'class="form-control input-sm">' +
        '</div>' +
      '</div>' +
      '<div class="col-xs-12 col-sm-4">' +
        '<button ' +
          'ng-disabled="vm.disabledAddButton" ' +
          'ng-bind="vm.newFolder ? \'Create and add to folder\' : \'Add to folder\'" ' +
          'ng-click="vm.save(vm.folder, vm.folderDescription)" ' +
          'class="btn btn-line-primary on-gray-bg btn-block btn-sm">' +
        '</button>' +
      '</div>' +
    '</div>' +
    '<div class="row" ng-if="vm.taggings && vm.taggings[0]">' +
      '<div class="col-xs-12">' +
        '<div class="folder-item" ng-repeat="tagging in vm.taggings">' +
          '<a ' +
            'class="tagging-text link-blue-orange" ' +
            'ng-href="/recruiter/search?filter[tag_ids][]={{tagging.tag.id}}" ' +
            'target="_blank" ' +
            'ng-bind="tagging.tag.name"' +
            'uib-tooltip="{{tagging.tag.description}}"' +
            'tooltip-popup-delay="800"' +
            'tooltip-class="description-tooltip" >' +
          '</a>' +
          '<a ' +
            'class="remove" ' +
            'ng-click="vm.remove(tagging)">' +
          '</a>' +
        '</div>' +
      '</div>' +
    '</div>' +
  '</div>';

angular.module('components.recruiterFolderSelect', [])
  .component('recruiterFolderSelect', {
    template: recruiterFolderSelectComponentTemplate,
    bindings: {
      data: '<',
      callback: '&',
      disabledAddButton: '<'
    },
    controller: [
      '$http',
      '$scope',
      'alertHandlingService',
      function RecruiterFolderSelectController($http, $scope, AlertHandling) {
        var that = this;
        that.folders = null;
        that.folder = null;
        that.folderDescription = null;
        that.newFolder = null;

        /**
         * Gets the name and description of the folder
         *
         * @param {object|string} folder - Folder from which get the values
         *
         * @returns {object} - Folder name and description
         */
        var getValue = function(folder) {
          return {
            name: folder && typeof folder === 'object' ? folder.name : folder,
            description: folder && typeof folder === 'object' ? folder.description : '',
          };
        };

        /**
         * Checks if there is a match between the given folder and the list of folders
         * If there is, it means we're not creating a folder, but selecting one, if not, we're
         * creating one
         *
         * @param {object|string} folder - Folder to be checked
         *
         * @returns {undefined}
         */
        that.checkMatches = function(folder) {
          const folderValues = getValue(folder);

          that.newFolder = !that.folders.filter(function(item) {
            return item.name === folderValues.name;
          }).length;

          that.folderDescription = folderValues.description;
        };

        /**
         * Gets all the tags for the typeahead
         *
         * @returns {undefined}
         */
        var init = function() {
          that.folders = [];
          that.folder = null;
          that.folderDescription = null;
          that.newFolder = true;
          that.taggings = null;

          getAllTags().then(function (response) {
            that.folders = response.data;
          });

          if (typeof that.data === 'number') {
            // When rendering the recruiter folder make API call to get folders
            // of selected user, which ID is represented by that.data
            queryTaggings(that.data)
              .then(function (response) {
                $scope.$apply(function () {
                  that.taggings = response.data;
                });
              });
          }
        };

        /**
         * Function to remove item from the folder
         *
         * @param {object} tagging - object representing a user inside a folder
         *
         * @returns {undefined}
         */
        that.remove = function(tagging) {
          removeTaggings([tagging.id])
            .then(function () {
              $scope.$apply(function () {
                that.taggings = that.taggings.filter(function (item) {
                  return item.id !== tagging.id;
                });
              });
            });
        };

        /**
         * Function to save the item into the folder
         *
         * @param {number|object} data - ID of the item or list of items that will be stored on the
         *                               folder
         * @param {object} folder - Folder on which the item will be stored
         *
         * @returns {undefined}
         */
        that.addToFolder = function (data, folder) {
          var target = data;

          if (data && angular.isObject(data)) {
            target = Object.keys(data);
          }

          addConsultantTagging(target, folder)
            .then(function () {
              AlertHandling.showSuccessMessage('Added to folder');
              $scope.$apply();
              init();
            });
        };

        /**
         * Function to create a folder
         *
         * @param {string} name - Name of the folder to be created
         * @param {string} description - Description of the folder to be created
         *
         * @returns {object} - Request promise object
         */
        var createFolder = function(name, description) {
          return $http.post('/api/public/current_user/tags', {
            'name': name,
            'description': description
          });
        };

        /**
         * Function to be called when saving, it checks if there is a value (if not shows an alert),
         * Afterwards it adds the item to the given folder
         *
         * @param {object|string} folder - Folder on which the item will be stored
         * @param {object|string} folderDescription - Description of the folder
         *
         * @returns {undefined}
         */
        that.save = function(folder, folderDescription) {
          if(folder) {
            if(that.newFolder) {
              createFolder(folder, folderDescription).then(function(response) {

                that.addToFolder(that.data, response.data.name);
                that.folderDescription = null;
                that.folder = null;
              });
            } else {
              that.addToFolder(that.data, getValue(folder).name);
            }
          } else {
            AlertHandling.showErrorMessage('Write the name of the target folder', 'error');
          }
        };

        /**
         * DATA OBTAINING
         */
        that.$onInit = init;
      }
    ],
    controllerAs: 'vm'
  });
